import Vue from "vue";
export var EngineerEventBus = new Vue();